import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

function Badge({ outlined, children }) {
  return (
    <Box
      component="div"
      sx={{
        fontSize: outlined ? "12px" : "14px",
        color: "grey",
        textTransform: "uppercase",
        padding: outlined ? "4px 10px" : 0,
        border: outlined ? "1px solid #E8E8E8" : "none",
        borderRadius: outlined ? "9999px" : 0,
        display: "inline-block",
      }}
    >
      {children}
    </Box>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  outlined: PropTypes.bool,
};

export default Badge;